import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { styles } from "../styles"
import { withStyles } from '@material-ui/core';


const SummaryView = ({ classes, data, colors, propertiesNumber, labels }) => {
  return <Box className={classes.summaryViewBox}>
    <Box className={classes.summaryData}>
      {data.firstColumn !== 0 && <DataView color={colors.firstColumn} labels={labels} property={labels.label1} number={data.firstColumn} classes={classes} />}
      {data.secondColumn !== 0 && <DataView color={colors.secondColumn} property={labels.label2} labels={labels} number={data.secondColumn} classes={classes} />}
      {data.thirdColumn !== 0 && <DataView color={colors.thirdColumn} property={labels.label3} labels={labels} number={data.thirdColumn} classes={classes} />}
      {propertiesNumber == 0 && (
        <DataView
          color={colors.fourthColumn || "#EEEEEE"}
          property={labels.label4 || "No Data to show"}
          labels={labels}
          classes={classes}
          emptyView={true}
        />
      )}
    </Box>

    <Box className={classes.summaryChartBox}>
      <SummaryChart colors={colors} classes={classes} data={data} propertiesNumber={propertiesNumber} />
    </Box>
  </Box>
}

const DataView = ({ classes, color, property, number, labels, emptyView }) => {
  return <Box className={classes.dataBox}>
    <Box className={classes.colorBox} style={{ background: color }}></Box>
    <Typography className={classes.dataText}>
      {emptyView ? (
        property
      ) : (
        <>
          {property}:
          <span>
            {number} {number > 1 ? labels.plural : labels.single}
          </span>
        </>
      )}
    </Typography>
  </Box>
}

const SummaryChart = ({ classes, colors, data, propertiesNumber }) => {
  const goalAchievedPercentage = (data.firstColumn / propertiesNumber) * 100
  const onTrackPercentage = (data.secondColumn / propertiesNumber) * 100
  const notOnTrackPercentage = (data.thirdColumn / propertiesNumber) * 100
  const style = {
    gridTemplateColumns: `${goalAchievedPercentage !== 0 ? goalAchievedPercentage + '%' : ''} ${onTrackPercentage !== 0 ? onTrackPercentage + '%' : ''} ${notOnTrackPercentage !== 0 ? notOnTrackPercentage + '%' : ''}`,
  }

  return <Box>
    <Box className={classes.summaryChart} style={style}>
      {propertiesNumber == 0 ? (
        <Box style={{ backgroundColor: colors.fourthColumn || "#EEEEEE" }} />
      ) : (
        <>
          {goalAchievedPercentage !== 0 && (
            <Box style={{ backgroundColor: colors.firstColumn }} />
          )}
          {onTrackPercentage !== 0 && <Box style={{ backgroundColor: colors.secondColumn }} />}
          {notOnTrackPercentage !== 0 && <Box style={{ backgroundColor: colors.thirdColumn }} />}
        </>
      )}
    </Box>

    <Box className={classes.summaryLabels} style={style}>
      <Typography className={classes.datumPoint}>0</Typography>
      {data.firstColumn !== 0 && (
        <Typography className={classes.container}>
          <div className={classes.marginLabel}>{data.firstColumn}</div>
        </Typography>
      )}
      {data.secondColumn !== 0 && (
        <Typography className={classes.container}>
          <div className={classes.marginLabel}>{data.secondColumn + data.firstColumn}</div>
        </Typography>
      )}
      {data.thirdColumn !== 0 && <Typography>{data.secondColumn + data.firstColumn + data.thirdColumn}</Typography>}
      {propertiesNumber == 0 && <Typography>0</Typography>}
    </Box>
  </Box>
}

export default withStyles(styles)(SummaryView)